(() => {
  const hoverDeviceQuery =
    '(min-width: 990px) and (hover: hover) and (pointer: fine)';

  const closeDelay = 150;

  function isDesktopHoverDevice() {
    return window.matchMedia(hoverDeviceQuery).matches;
  }

  function setMenuState(details, open) {
    const summary = details.querySelector(':scope > summary');

    if (open) {
      details.setAttribute('open', '');
      summary?.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      summary?.setAttribute('aria-expanded', 'false');
    }
  }

  function closeOtherMenus(currentDetails) {
    document
      .querySelectorAll('.header__inline-menu details.hover-menu[open]')
      .forEach((details) => {
        if (details !== currentDetails) {
          setMenuState(details, false);
        }
      });
  }

  function initialiseHoverMenus(scope = document) {
    const menus = scope.querySelectorAll(
      '.header__inline-menu details.hover-menu'
    );

    menus.forEach((details) => {
      if (details.dataset.hoverMenuInitialised === 'true') return;

      details.dataset.hoverMenuInitialised = 'true';

      const summary = details.querySelector(':scope > summary');
      const menuContainer = details.closest('header-menu');

      if (!summary || !menuContainer) return;

      let closeTimer;

      const openMenu = () => {
        if (!isDesktopHoverDevice()) return;

        window.clearTimeout(closeTimer);
        closeOtherMenus(details);
        setMenuState(details, true);
      };

      const closeMenu = () => {
        if (!isDesktopHoverDevice()) return;

        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          setMenuState(details, false);
        }, closeDelay);
      };

      menuContainer.addEventListener('mouseenter', openMenu);
      menuContainer.addEventListener('mouseleave', closeMenu);

      summary.addEventListener('click', (event) => {
        /*
         * Mouse clicks visit the parent page.
         * Keyboard and touchscreen controls retain Dawn's normal behaviour.
         */
        if (!isDesktopHoverDevice() || event.detail === 0) return;

        const parentUrl = details.dataset.parentUrl;

        if (!parentUrl || parentUrl === '#') return;

        event.preventDefault();

        if (event.ctrlKey || event.metaKey) {
          window.open(parentUrl, '_blank', 'noopener');
          return;
        }

        window.location.assign(parentUrl);
      });
    });
  }

  function initialise() {
    initialiseHoverMenus(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseHoverMenus(event.target);
  });
})();